import { create } from 'zustand';

import type { StreamEventPayload } from '../constants/types/stream';

type StreamCallback = (payload: StreamEventPayload) => void;

interface StreamChannelState {
  _callbacks: Map<string, StreamCallback>;
  connect: (() => void) | null;
  count: number;
  disconnect: (() => void) | null;
  isConnected: boolean;
}

interface StreamChannelActions {
  publish(payload: StreamEventPayload): void;
  setControls(connect: () => void, disconnect: () => void): void;
  setCount(count: number): void;
  setIsConnected(isConnected: boolean): void;
  subscribe(id: string, callback: StreamCallback): void;
  unsubscribe(id: string): void;
}

export type StreamChannelStore = StreamChannelState & StreamChannelActions;

export const useStreamChannelStore = create<StreamChannelStore>()((set, get) => ({
  _callbacks: new Map(),
  connect: null,
  count: 0,
  disconnect: null,
  isConnected: false,
  subscribe: (id, callback) => {
    set(state => {
      const next = new Map(state._callbacks);
      next.set(id, callback);
      return { _callbacks: next };
    });
  },
  unsubscribe: id => {
    set(state => {
      if (!state._callbacks.has(id)) return state;
      const next = new Map(state._callbacks);
      next.delete(id);
      return { _callbacks: next };
    });
  },
  publish: payload => {
    const { _callbacks } = get();
    _callbacks.forEach(callback => {
      try {
        callback(payload);
      } catch (error) {
        console.error('[STREAM] callback error:', error);
      }
    });
  },
  setControls: (connect, disconnect) => {
    set({ connect, disconnect });
  },
  setCount: count => {
    set({ count });
  },
  setIsConnected: isConnected => {
    set({ isConnected });
  },
}));
